var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 23.2085H15.625C16.2693 23.2085 16.7917 23.7308 16.7917 24.3752V25.8335C16.7917 26.4779 16.2693 27.0002 15.625 27.0002H14.1667C13.5223 27.0002 13 26.4779 13 25.8335V24.3752C13 23.7308 13.5223 23.2085 14.1667 23.2085Z",
    fill: "#14507C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3752 23.2085H25.8335C26.4779 23.2085 27.0002 23.7308 27.0002 24.3752V25.8335C27.0002 26.4779 26.4779 27.0002 25.8335 27.0002H24.3752C23.7308 27.0002 23.2085 26.4779 23.2085 25.8335V24.3752C23.2085 23.7308 23.7308 23.2085 24.3752 23.2085Z",
    fill: "#14507C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.104H15.625C16.2693 18.104 16.7917 18.6264 16.7917 19.2707V20.729C16.7917 21.3733 16.2693 21.8957 15.625 21.8957H14.1667C13.5223 21.8957 13 21.3733 13 20.729V19.2707C13 18.6263 13.5223 18.104 14.1667 18.104Z",
    fill: "#14507C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3752 18.104H25.8335C26.4778 18.104 27.0002 18.6264 27.0002 19.2707V20.729C27.0002 21.3733 26.4779 21.8957 25.8335 21.8957H24.3752C23.7308 21.8957 23.2085 21.3733 23.2085 20.729V19.2707C23.2085 18.6263 23.7308 18.104 24.3752 18.104Z",
    fill: "#14507C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 13H15.625C16.2693 13 16.7917 13.5223 16.7917 14.1667V15.625C16.7917 16.2693 16.2693 16.7917 15.625 16.7917H14.1667C13.5223 16.7917 13 16.2693 13 15.625V14.1667C13 13.5223 13.5223 13 14.1667 13Z",
    fill: "#14507C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2707 23.2085H20.729C21.3733 23.2085 21.8957 23.7308 21.8957 24.3752V25.8335C21.8957 26.4778 21.3733 27.0002 20.729 27.0002H19.2707C18.6264 27.0002 18.104 26.4779 18.104 25.8335V24.3752C18.104 23.7308 18.6264 23.2085 19.2707 23.2085Z",
    fill: "#14507C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2707 18.104H20.729C21.3733 18.104 21.8957 18.6264 21.8957 19.2707V20.729C21.8957 21.3733 21.3733 21.8957 20.729 21.8957H19.2707C18.6264 21.8957 18.104 21.3733 18.104 20.729V19.2707C18.104 18.6263 18.6264 18.104 19.2707 18.104Z",
    fill: "#14507C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2707 13H20.729C21.3733 13 21.8957 13.5223 21.8957 14.1667V15.625C21.8957 16.2693 21.3733 16.7917 20.729 16.7917H19.2707C18.6264 16.7917 18.104 16.2693 18.104 15.625V14.1667C18.104 13.5223 18.6264 13 19.2707 13Z",
    fill: "#14507C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3752 13H25.8335C26.4779 13 27.0002 13.5223 27.0002 14.1667V15.625C27.0002 16.2693 26.4779 16.7917 25.8335 16.7917H24.3752C23.7308 16.7917 23.2085 16.2693 23.2085 15.625V14.1667C23.2085 13.5223 23.7308 13 24.3752 13Z",
    fill: "#14507C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.4013305ccd56fc7e0388a2f2f439e1d8.svg";
export { ForwardRef as ReactComponent };